import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase';
import PlayerSelectorModal from '../Player/templates/PlayerSelectorModal';

function AddLegendStats({teamId}) {

    const [player, setPlayer] = useState();

    const [name, setName] = useState("")
    const [goals, setGoals] = useState(0)
    const [fixtures, setFixtures] = useState(0);
    const [assists, setAssists] = useState(0);
    const [image, setImage] = useState("https://firebasestorage.googleapis.com/v0/b/backend-footgrail.appspot.com/o/players%2Favatar-default.jpg?alt=media&token=06ae4bfc-6276-40aa-ad58-0968fea10f8e");

    async function addStats(e) {
        e.preventDefault()
        try {
            const teamStatsRef = firestore.collection("teams").doc(teamId).collection("total-stats");

            const data = {
                player_name: player?.player_name || name,
                goals,
                fixtures,
                assists,
                player_image: player?.player_parent_id || image,
                player_parent_id: player?.id
            }

            teamStatsRef.add(data)

            setPlayer(null)
            setName("")
            setGoals(0)
            setFixtures(0)
            setAssists(0)
            setImage("https://firebasestorage.googleapis.com/v0/b/backend-footgrail.appspot.com/o/players%2Favatar-default.jpg?alt=media&token=06ae4bfc-6276-40aa-ad58-0968fea10f8e")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        // Get global players and selected players parent info
        if (player) {
            setImage(player.player_image)
            setName(player.player_name);
            //setPlayerParentId(player.id);
            //setPlayerId(player.id)
        }
    }, [player])

    return (
        <form onSubmit={addStats}>

            <PlayerSelectorModal selectedPlayer={player} setSelectedPlayer={setPlayer} />
            <br />

            <label>Navn</label>
            <input className="form-control mb-2" value={name} onChange={e => setName(e.target.value)}  />

            <label>Spillerbilde</label>
            <input className="form-control mb-2" value={image} onChange={e => setImage(e.target.value)}  />

            <div className="my-5 row">
                <div className="col-lg-2 col-md-4">
                    <img src={image} alt="player-profile" />
                </div>
            </div>

            <label>Kamper</label>
            <input className="form-control mb-2" type="number" value={fixtures} onChange={e => setFixtures(e.target.value)}  />

            <label>Mål</label>
            <input className="form-control mb-2" type="number" value={goals} onChange={e => setGoals(e.target.value)} />

            <label>Assist</label>
            <input className="form-control mb-2" type="number" value={assists} onChange={e => setAssists(e.target.value)}  />

            <button className="btn btn-rounded btn-primary">Legg til stats</button>
        </form>
    )

}
export default AddLegendStats